import { Header } from "@caint/design-system";
import { Fragment } from "react";
import { PanoramaRede } from "../components/panorama/PanoramaRede.tsx";
import type { Panorama as PanoramaData } from "../lib/panorama.ts";

/** Wrapper mobile do Panorama da Rede (comparativo entre unidades). */
export function Panorama({ panorama, onBack }: { panorama: PanoramaData | null; onBack: () => void }) {
  return (
    <Fragment>
      <Header title="Panorama da Rede" sub="Comparativo entre unidades" onBack={onBack} />
      <div className="m-body">
        {panorama ? (
          <Fragment>
            <div
              className="no-print"
              style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}
            >
              <button type="button" className="m-btn" onClick={() => window.print()}>
                🖨 Imprimir / PDF
              </button>
            </div>
            <PanoramaRede panorama={panorama} />
          </Fragment>
        ) : (
          <p className="spec">Panorama disponível apenas para a gestão da rede.</p>
        )}
      </div>
    </Fragment>
  );
}
